<template>
  <div class="target-selector-preview">
    <sp-icon v-if="iconName" :name="iconName"></sp-icon>
    <a
      v-if="url"
      class="target-selector-preview__link"
      :href="url"
      target="_blank"
      rel="noopener"
      :title="t('target_selector_preview_title')"
      >{{ label }}</a
    >
    <span v-else class="target-selector-preview__link">{{ label }}</span>
  </div>
</template>

<script setup>
import { t } from "#ce/shared/components-i18n";

defineProps({
  /**
   * Admin icon-manifest key for the record, empty while loading or when the record cannot be
   * described.
   *
   * @type {String}
   */
  iconName: {
    type: String,
    default: "",
  },
  /**
   * @type {String}
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Url the label links to; empty renders the label as plain text.
   *
   * @type {String}
   */
  url: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.target-selector-preview {
  align-items: center;
  display: flex;
  gap: var(--sp-ref-scale-4);
  min-height: var(--sp-sys-icon-size-medium);

  &__link {
    color: var(--sp-sys-color-link, inherit);
    font: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
